import api from "../api"
export const Auth = async (email, password) => {
  return await api.post('/api/v1/auth', {email, password});
}